import { RouteObject } from 'react-router/dist/lib/context';
import { Topology } from './components';

export const topologyRoutes: RouteObject[] = [
  {
    path: '',
    element: <Topology />,
  },
];
